
const cidadesBahia = [
  {
    'id': 2900108,
    'nome': 'Abaíra'
  },
  {
    'id': 2900207,
    'nome': 'Abaré'
  },
  {
    'id': 2900306,
    'nome': 'Acajutiba'
  },
  {
    'id': 2900355,
    'nome': 'Adustina'
  },
  {
    'id': 2900603,
    'nome': 'Aiquara'
  },
  {
    'id': 2900702,
    'nome': 'Alagoinhas'
  },
  {
    'id': 2900801,
    'nome': 'Alcobaça'
  },
  {
    'id': 2900900,
    'nome': 'Almadina'
  },
  {
    'id': 2901007,
    'nome': 'Amargosa'
  },
  {
    'id': 2901106,
    'nome': 'Amélia Rodrigues'
  },
  {
    'id': 2901155,
    'nome': 'América Dourada'
  },
  {
    'id': 2901205,
    'nome': 'Anagé'
  },
  {
    'id': 2901304,
    'nome': 'Andaraí'
  },
  {
    'id': 2901353,
    'nome': 'Andorinha'
  },
  {
    'id': 2901403,
    'nome': 'Angical'
  },
  {
    'id': 2901502,
    'nome': 'Anguera'
  },
  {
    'id': 2901601,
    'nome': 'Antas'
  },
  {
    'id': 2901700,
    'nome': 'Antônio Cardoso'
  },
  {
    'id': 2901809,
    'nome': 'Antônio Gonçalves'
  },
  {
    'id': 2901908,
    'nome': 'Aporá'
  },
  {
    'id': 2901957,
    'nome': 'Apuarema'
  },
  {
    'id': 2902005,
    'nome': 'Aracatu'
  },
  {
    'id': 2902054,
    'nome': 'Araças'
  },
  {
    'id': 2902104,
    'nome': 'Araci'
  },
  {
    'id': 2902203,
    'nome': 'Aramari'
  },
  {
    'id': 2902252,
    'nome': 'Arataca'
  },
  {
    'id': 2902302,
    'nome': 'Aratuípe'
  },
  {
    'id': 2902401,
    'nome': 'Aurelino Leal'
  },
  {
    'id': 2900405,
    'nome': 'Água Fria'
  },
  {
    'id': 2902500,
    'nome': 'Baianópolis'
  },
  {
    'id': 2902609,
    'nome': 'Baixa Grande'
  },
  {
    'id': 2902658,
    'nome': 'Banzaê'
  },
  {
    'id': 2902708,
    'nome': 'Barra'
  },
  {
    'id': 2902807,
    'nome': 'Barra da Estiva'
  },
  {
    'id': 2902906,
    'nome': 'Barra do Choça'
  },
  {
    'id': 2903003,
    'nome': 'Barra do Mendes'
  },
  {
    'id': 2903102,
    'nome': 'Barra do Rocha'
  },
  {
    'id': 2903201,
    'nome': 'Barreiras'
  },
  {
    'id': 2903235,
    'nome': 'Barro Alto'
  },
  {
    'id': 2903276,
    'nome': 'Barrocas'
  },
  {
    'id': 2903300,
    'nome': 'Barro Preto'
  },
  {
    'id': 2903409,
    'nome': 'Belmonte'
  },
  {
    'id': 2903508,
    'nome': 'Belo Campo'
  },
  {
    'id': 2903607,
    'nome': 'Biritinga'
  },
  {
    'id': 2903706,
    'nome': 'Boa Nova'
  },
  {
    'id': 2903805,
    'nome': 'Boa Vista do Tupim'
  },
  {
    'id': 2903904,
    'nome': 'Bom Jesus da Lapa'
  },
  {
    'id': 2903953,
    'nome': 'Bom Jesus da Serra'
  },
  {
    'id': 2904001,
    'nome': 'Boninal'
  },
  {
    'id': 2904050,
    'nome': 'Bonito'
  },
  {
    'id': 2904100,
    'nome': 'Boquira'
  },
  {
    'id': 2904209,
    'nome': 'Botuporã'
  },
  {
    'id': 2904308,
    'nome': 'Brejões'
  },
  {
    'id': 2904407,
    'nome': 'Brejolândia'
  },
  {
    'id': 2904506,
    'nome': 'Brotas de Macaúbas'
  },
  {
    'id': 2904605,
    'nome': 'Brumado'
  },
  {
    'id': 2904704,
    'nome': 'Buerarema'
  },
  {
    'id': 2904753,
    'nome': 'Buritirama'
  },
  {
    'id': 2904803,
    'nome': 'Caatiba'
  },
  {
    'id': 2904852,
    'nome': 'Cabaceiras do Paraguaçu'
  },
  {
    'id': 2904902,
    'nome': 'Cachoeira'
  },
  {
    'id': 2905008,
    'nome': 'Caculé'
  },
  {
    'id': 2905107,
    'nome': 'Caém'
  },
  {
    'id': 2905156,
    'nome': 'Caetanos'
  },
  {
    'id': 2905206,
    'nome': 'Caetité'
  },
  {
    'id': 2905305,
    'nome': 'Cafarnaum'
  },
  {
    'id': 2905404,
    'nome': 'Cairu'
  },
  {
    'id': 2905503,
    'nome': 'Caldeirão Grande'
  },
  {
    'id': 2905602,
    'nome': 'Camacan'
  },
  {
    'id': 2905701,
    'nome': 'Camaçari'
  },
  {
    'id': 2905800,
    'nome': 'Camamu'
  },
  {
    'id': 2905909,
    'nome': 'Campo Alegre de Lourdes'
  },
  {
    'id': 2906006,
    'nome': 'Campo Formoso'
  },
  {
    'id': 2906105,
    'nome': 'Canápolis'
  },
  {
    'id': 2906204,
    'nome': 'Canarana'
  },
  {
    'id': 2906303,
    'nome': 'Canavieiras'
  },
  {
    'id': 2906402,
    'nome': 'Candeal'
  },
  {
    'id': 2906501,
    'nome': 'Candeias'
  },
  {
    'id': 2906600,
    'nome': 'Candiba'
  },
  {
    'id': 2906709,
    'nome': 'Cândido Sales'
  },
  {
    'id': 2906808,
    'nome': 'Cansanção'
  },
  {
    'id': 2906824,
    'nome': 'Canudos'
  },
  {
    'id': 2906857,
    'nome': 'Capela do Alto Alegre'
  },
  {
    'id': 2906873,
    'nome': 'Capim Grosso'
  },
  {
    'id': 2906899,
    'nome': 'Caraíbas'
  },
  {
    'id': 2906907,
    'nome': 'Caravelas'
  },
  {
    'id': 2907004,
    'nome': 'Cardeal da Silva'
  },
  {
    'id': 2907103,
    'nome': 'Carinhanha'
  },
  {
    'id': 2907202,
    'nome': 'Casa Nova'
  },
  {
    'id': 2907301,
    'nome': 'Castro Alves'
  },
  {
    'id': 2907400,
    'nome': 'Catolândia'
  },
  {
    'id': 2907509,
    'nome': 'Catu'
  },
  {
    'id': 2907558,
    'nome': 'Caturama'
  },
  {
    'id': 2907608,
    'nome': 'Central'
  },
  {
    'id': 2907707,
    'nome': 'Chorrochó'
  },
  {
    'id': 2907806,
    'nome': 'Cícero Dantas'
  },
  {
    'id': 2907905,
    'nome': 'Cipó'
  },
  {
    'id': 2908002,
    'nome': 'Coaraci'
  },
  {
    'id': 2908101,
    'nome': 'Cocos'
  },
  {
    'id': 2908200,
    'nome': 'Conceição da Feira'
  },
  {
    'id': 2908309,
    'nome': 'Conceição do Almeida'
  },
  {
    'id': 2908408,
    'nome': 'Conceição do Coité'
  },
  {
    'id': 2908507,
    'nome': 'Conceição do Jacuípe'
  },
  {
    'id': 2908606,
    'nome': 'Conde'
  },
  {
    'id': 2908705,
    'nome': 'Condeúba'
  },
  {
    'id': 2908804,
    'nome': 'Contendas do Sincorá'
  },
  {
    'id': 2908903,
    'nome': 'Coração de Maria'
  },
  {
    'id': 2909000,
    'nome': 'Cordeiros'
  },
  {
    'id': 2909109,
    'nome': 'Coribe'
  },
  {
    'id': 2909208,
    'nome': 'Coronel João Sá'
  },
  {
    'id': 2909307,
    'nome': 'Correntina'
  },
  {
    'id': 2909406,
    'nome': 'Cotegipe'
  },
  {
    'id': 2909505,
    'nome': 'Cravolândia'
  },
  {
    'id': 2909604,
    'nome': 'Crisópolis'
  },
  {
    'id': 2909703,
    'nome': 'Cristópolis'
  },
  {
    'id': 2909802,
    'nome': 'Cruz das Almas'
  },
  {
    'id': 2909901,
    'nome': 'Curaçá'
  },
  {
    'id': 2910008,
    'nome': 'Dário Meira'
  },
  {
    'id': 2910057,
    'nome': 'Dias D\'Ávila'
  },
  {
    'id': 2910107,
    'nome': 'Dom Basílio'
  },
  {
    'id': 2910206,
    'nome': 'Dom Macedo Costa'
  },
  {
    'id': 2910305,
    'nome': 'Elísio Medrado'
  },
  {
    'id': 2910404,
    'nome': 'Encruzilhada'
  },
  {
    'id': 2910503,
    'nome': 'Entre Rios'
  },
  {
    'id': 2910602,
    'nome': 'Esplanada'
  },
  {
    'id': 2910701,
    'nome': 'Euclides da Cunha'
  },
  {
    'id': 2910727,
    'nome': 'Eunápolis'
  },
  {
    'id': 2900504,
    'nome': 'Érico Cardoso'
  },
  {
    'id': 2910750,
    'nome': 'Fátima'
  },
  {
    'id': 2910776,
    'nome': 'Feira da Mata'
  },
  {
    'id': 2910800,
    'nome': 'Feira de Santana'
  },
  {
    'id': 2910859,
    'nome': 'Filadélfia'
  },
  {
    'id': 2910909,
    'nome': 'Firmino Alves'
  },
  {
    'id': 2911006,
    'nome': 'Floresta Azul'
  },
  {
    'id': 2911105,
    'nome': 'Formosa do Rio Preto'
  },
  {
    'id': 2911204,
    'nome': 'Gandu'
  },
  {
    'id': 2911253,
    'nome': 'Gavião'
  },
  {
    'id': 2911303,
    'nome': 'Gentio do Ouro'
  },
  {
    'id': 2911402,
    'nome': 'Glória'
  },
  {
    'id': 2911501,
    'nome': 'Gongogi'
  },
  {
    'id': 2911600,
    'nome': 'Governador Mangabeira'
  },
  {
    'id': 2911659,
    'nome': 'Guajeru'
  },
  {
    'id': 2911709,
    'nome': 'Guanambi'
  },
  {
    'id': 2911808,
    'nome': 'Guaratinga'
  },
  {
    'id': 2911857,
    'nome': 'Heliópolis'
  },
  {
    'id': 2911907,
    'nome': 'Iaçu'
  },
  {
    'id': 2912004,
    'nome': 'Ibiassucê'
  },
  {
    'id': 2912103,
    'nome': 'Ibicaraí'
  },
  {
    'id': 2912202,
    'nome': 'Ibicoara'
  },
  {
    'id': 2912301,
    'nome': 'Ibicuí'
  },
  {
    'id': 2912400,
    'nome': 'Ibipeba'
  },
  {
    'id': 2912509,
    'nome': 'Ibipitanga'
  },
  {
    'id': 2912608,
    'nome': 'Ibiquera'
  },
  {
    'id': 2912707,
    'nome': 'Ibirapitanga'
  },
  {
    'id': 2912806,
    'nome': 'Ibirapuã'
  },
  {
    'id': 2912905,
    'nome': 'Ibirataia'
  },
  {
    'id': 2913002,
    'nome': 'Ibitiara'
  },
  {
    'id': 2913101,
    'nome': 'Ibititá'
  },
  {
    'id': 2913200,
    'nome': 'Ibotirama'
  },
  {
    'id': 2913309,
    'nome': 'Ichu'
  },
  {
    'id': 2913408,
    'nome': 'Igaporã'
  },
  {
    'id': 2913457,
    'nome': 'Igrapiúna'
  },
  {
    'id': 2913507,
    'nome': 'Iguaí'
  },
  {
    'id': 2913606,
    'nome': 'Ilhéus'
  },
  {
    'id': 2913705,
    'nome': 'Inhambupe'
  },
  {
    'id': 2913804,
    'nome': 'Ipecaetá'
  },
  {
    'id': 2913903,
    'nome': 'Ipiaú'
  },
  {
    'id': 2914000,
    'nome': 'Ipirá'
  },
  {
    'id': 2914109,
    'nome': 'Ipupiara'
  },
  {
    'id': 2914208,
    'nome': 'Irajuba'
  },
  {
    'id': 2914307,
    'nome': 'Iramaia'
  },
  {
    'id': 2914406,
    'nome': 'Iraquara'
  },
  {
    'id': 2914505,
    'nome': 'Irará'
  },
  {
    'id': 2914604,
    'nome': 'Irecê'
  },
  {
    'id': 2914653,
    'nome': 'Itabela'
  },
  {
    'id': 2914703,
    'nome': 'Itaberaba'
  },
  {
    'id': 2914802,
    'nome': 'Itabuna'
  },
  {
    'id': 2914901,
    'nome': 'Itacaré'
  },
  {
    'id': 2915007,
    'nome': 'Itaeté'
  },
  {
    'id': 2915106,
    'nome': 'Itagi'
  },
  {
    'id': 2915205,
    'nome': 'Itagibá'
  },
  {
    'id': 2915304,
    'nome': 'Itagimirim'
  },
  {
    'id': 2915353,
    'nome': 'Itaguaçu da Bahia'
  },
  {
    'id': 2915403,
    'nome': 'Itaju do Colônia'
  },
  {
    'id': 2915502,
    'nome': 'Itajuípe'
  },
  {
    'id': 2915601,
    'nome': 'Itamaraju'
  },
  {
    'id': 2915700,
    'nome': 'Itamari'
  },
  {
    'id': 2915809,
    'nome': 'Itambé'
  },
  {
    'id': 2915908,
    'nome': 'Itanagra'
  },
  {
    'id': 2916005,
    'nome': 'Itanhém'
  },
  {
    'id': 2916104,
    'nome': 'Itaparica'
  },
  {
    'id': 2916203,
    'nome': 'Itapé'
  },
  {
    'id': 2916302,
    'nome': 'Itapebi'
  },
  {
    'id': 2916401,
    'nome': 'Itapetinga'
  },
  {
    'id': 2916500,
    'nome': 'Itapicuru'
  },
  {
    'id': 2916609,
    'nome': 'Itapitanga'
  },
  {
    'id': 2916708,
    'nome': 'Itaquara'
  },
  {
    'id': 2916807,
    'nome': 'Itarantim'
  },
  {
    'id': 2916856,
    'nome': 'Itatim'
  },
  {
    'id': 2916906,
    'nome': 'Itiruçu'
  },
  {
    'id': 2917003,
    'nome': 'Itiúba'
  },
  {
    'id': 2917102,
    'nome': 'Itororó'
  },
  {
    'id': 2917201,
    'nome': 'Ituaçu'
  },
  {
    'id': 2917300,
    'nome': 'Ituberá'
  },
  {
    'id': 2917334,
    'nome': 'Iuiú'
  },
  {
    'id': 2917359,
    'nome': 'Jaborandi'
  },
  {
    'id': 2917409,
    'nome': 'Jacaraci'
  },
  {
    'id': 2917508,
    'nome': 'Jacobina'
  },
  {
    'id': 2917607,
    'nome': 'Jaguaquara'
  },
  {
    'id': 2917706,
    'nome': 'Jaguarari'
  },
  {
    'id': 2917805,
    'nome': 'Jaguaripe'
  },
  {
    'id': 2917904,
    'nome': 'Jandaíra'
  },
  {
    'id': 2918001,
    'nome': 'Jequié'
  },
  {
    'id': 2918100,
    'nome': 'Jeremoabo'
  },
  {
    'id': 2918209,
    'nome': 'Jiquiriçá'
  },
  {
    'id': 2918308,
    'nome': 'Jitaúna'
  },
  {
    'id': 2918357,
    'nome': 'João Dourado'
  },
  {
    'id': 2918407,
    'nome': 'Juazeiro'
  },
  {
    'id': 2918456,
    'nome': 'Jucuruçu'
  },
  {
    'id': 2918506,
    'nome': 'Jussara'
  },
  {
    'id': 2918555,
    'nome': 'Jussari'
  },
  {
    'id': 2918605,
    'nome': 'Jussiape'
  },
  {
    'id': 2918704,
    'nome': 'Lafaiete Coutinho'
  },
  {
    'id': 2918753,
    'nome': 'Lagoa Real'
  },
  {
    'id': 2918803,
    'nome': 'Laje'
  },
  {
    'id': 2918902,
    'nome': 'Lajedão'
  },
  {
    'id': 2919009,
    'nome': 'Lajedinho'
  },
  {
    'id': 2919058,
    'nome': 'Lajedo do Tabocal'
  },
  {
    'id': 2919108,
    'nome': 'Lamarão'
  },
  {
    'id': 2919157,
    'nome': 'Lapão'
  },
  {
    'id': 2919207,
    'nome': 'Lauro de Freitas'
  },
  {
    'id': 2919306,
    'nome': 'Lençóis'
  },
  {
    'id': 2919405,
    'nome': 'Licínio de Almeida'
  },
  {
    'id': 2919504,
    'nome': 'Livramento de Nossa Senhora'
  },
  {
    'id': 2919553,
    'nome': 'Luís Eduardo Magalhães'
  },
  {
    'id': 2919603,
    'nome': 'Macajuba'
  },
  {
    'id': 2919702,
    'nome': 'Macarani'
  },
  {
    'id': 2919801,
    'nome': 'Macaúbas'
  },
  {
    'id': 2919900,
    'nome': 'Macururé'
  },
  {
    'id': 2919926,
    'nome': 'Madre de Deus'
  },
  {
    'id': 2919959,
    'nome': 'Maetinga'
  },
  {
    'id': 2920007,
    'nome': 'Maiquinique'
  },
  {
    'id': 2920106,
    'nome': 'Mairi'
  },
  {
    'id': 2920205,
    'nome': 'Malhada'
  },
  {
    'id': 2920304,
    'nome': 'Malhada de Pedras'
  },
  {
    'id': 2920403,
    'nome': 'Manoel Vitorino'
  },
  {
    'id': 2920452,
    'nome': 'Mansidão'
  },
  {
    'id': 2920502,
    'nome': 'Maracás'
  },
  {
    'id': 2920601,
    'nome': 'Maragogipe'
  },
  {
    'id': 2920700,
    'nome': 'Maraú'
  },
  {
    'id': 2920809,
    'nome': 'Marcionílio Souza'
  },
  {
    'id': 2920908,
    'nome': 'Mascote'
  },
  {
    'id': 2921005,
    'nome': 'Mata de São João'
  },
  {
    'id': 2921054,
    'nome': 'Matina'
  },
  {
    'id': 2921104,
    'nome': 'Medeiros Neto'
  },
  {
    'id': 2921203,
    'nome': 'Miguel Calmon'
  },
  {
    'id': 2921302,
    'nome': 'Milagres'
  },
  {
    'id': 2921401,
    'nome': 'Mirangaba'
  },
  {
    'id': 2921450,
    'nome': 'Mirante'
  },
  {
    'id': 2921500,
    'nome': 'Monte Santo'
  },
  {
    'id': 2921609,
    'nome': 'Morpará'
  },
  {
    'id': 2921708,
    'nome': 'Morro do Chapéu'
  },
  {
    'id': 2921807,
    'nome': 'Mortugaba'
  },
  {
    'id': 2921906,
    'nome': 'Mucugê'
  },
  {
    'id': 2922003,
    'nome': 'Mucuri'
  },
  {
    'id': 2922052,
    'nome': 'Mulungu do Morro'
  },
  {
    'id': 2922102,
    'nome': 'Mundo Novo'
  },
  {
    'id': 2922201,
    'nome': 'Muniz Ferreira'
  },
  {
    'id': 2922250,
    'nome': 'Muquém de São Francisco'
  },
  {
    'id': 2922300,
    'nome': 'Muritiba'
  },
  {
    'id': 2922409,
    'nome': 'Mutuípe'
  },
  {
    'id': 2922508,
    'nome': 'Nazaré'
  },
  {
    'id': 2922607,
    'nome': 'Nilo Peçanha'
  },
  {
    'id': 2922656,
    'nome': 'Nordestina'
  },
  {
    'id': 2922706,
    'nome': 'Nova Canaã'
  },
  {
    'id': 2922730,
    'nome': 'Nova Fátima'
  },
  {
    'id': 2922755,
    'nome': 'Nova Ibiá'
  },
  {
    'id': 2922805,
    'nome': 'Nova Itarana'
  },
  {
    'id': 2922854,
    'nome': 'Nova Redenção'
  },
  {
    'id': 2922904,
    'nome': 'Nova Soure'
  },
  {
    'id': 2923001,
    'nome': 'Nova Viçosa'
  },
  {
    'id': 2923035,
    'nome': 'Novo Horizonte'
  },
  {
    'id': 2923050,
    'nome': 'Novo Triunfo'
  },
  {
    'id': 2923100,
    'nome': 'Olindina'
  },
  {
    'id': 2923209,
    'nome': 'Oliveira dos Brejinhos'
  },
  {
    'id': 2923308,
    'nome': 'Ouriçangas'
  },
  {
    'id': 2923357,
    'nome': 'Ourolândia'
  },
  {
    'id': 2923407,
    'nome': 'Palmas de Monte Alto'
  },
  {
    'id': 2923506,
    'nome': 'Palmeiras'
  },
  {
    'id': 2923605,
    'nome': 'Paramirim'
  },
  {
    'id': 2923704,
    'nome': 'Paratinga'
  },
  {
    'id': 2923803,
    'nome': 'Paripiranga'
  },
  {
    'id': 2923902,
    'nome': 'Pau Brasil'
  },
  {
    'id': 2924009,
    'nome': 'Paulo Afonso'
  },
  {
    'id': 2924058,
    'nome': 'Pé de Serra'
  },
  {
    'id': 2924108,
    'nome': 'Pedrão'
  },
  {
    'id': 2924207,
    'nome': 'Pedro Alexandre'
  },
  {
    'id': 2924306,
    'nome': 'Piatã'
  },
  {
    'id': 2924405,
    'nome': 'Pilão Arcado'
  },
  {
    'id': 2924504,
    'nome': 'Pindaí'
  },
  {
    'id': 2924603,
    'nome': 'Pindobaçu'
  },
  {
    'id': 2924652,
    'nome': 'Pintadas'
  },
  {
    'id': 2924678,
    'nome': 'Piraí do Norte'
  },
  {
    'id': 2924702,
    'nome': 'Piripá'
  },
  {
    'id': 2924801,
    'nome': 'Piritiba'
  },
  {
    'id': 2924900,
    'nome': 'Planaltino'
  },
  {
    'id': 2925006,
    'nome': 'Planalto'
  },
  {
    'id': 2925105,
    'nome': 'Poções'
  },
  {
    'id': 2925204,
    'nome': 'Pojuca'
  },
  {
    'id': 2925253,
    'nome': 'Ponto Novo'
  },
  {
    'id': 2925303,
    'nome': 'Porto Seguro'
  },
  {
    'id': 2925402,
    'nome': 'Potiraguá'
  },
  {
    'id': 2925501,
    'nome': 'Prado'
  },
  {
    'id': 2925600,
    'nome': 'Presidente Dutra'
  },
  {
    'id': 2925709,
    'nome': 'Presidente Jânio Quadros'
  },
  {
    'id': 2925758,
    'nome': 'Presidente Tancredo Neves'
  },
  {
    'id': 2925808,
    'nome': 'Queimadas'
  },
  {
    'id': 2925907,
    'nome': 'Quijingue'
  },
  {
    'id': 2925931,
    'nome': 'Quixabeira'
  },
  {
    'id': 2925956,
    'nome': 'Rafael Jambeiro'
  },
  {
    'id': 2926004,
    'nome': 'Remanso'
  },
  {
    'id': 2926103,
    'nome': 'Retirolândia'
  },
  {
    'id': 2926202,
    'nome': 'Riachão das Neves'
  },
  {
    'id': 2926301,
    'nome': 'Riachão do Jacuípe'
  },
  {
    'id': 2926400,
    'nome': 'Riacho de Santana'
  },
  {
    'id': 2926509,
    'nome': 'Ribeira do Amparo'
  },
  {
    'id': 2926608,
    'nome': 'Ribeira do Pombal'
  },
  {
    'id': 2926657,
    'nome': 'Ribeirão do Largo'
  },
  {
    'id': 2926707,
    'nome': 'Rio de Contas'
  },
  {
    'id': 2926806,
    'nome': 'Rio do Antônio'
  },
  {
    'id': 2926905,
    'nome': 'Rio do Pires'
  },
  {
    'id': 2927002,
    'nome': 'Rio Real'
  },
  {
    'id': 2927101,
    'nome': 'Rodelas'
  },
  {
    'id': 2927200,
    'nome': 'Ruy Barbosa'
  },
  {
    'id': 2927309,
    'nome': 'Salinas da Margarida'
  },
  {
    'id': 2927408,
    'nome': 'Salvador'
  },
  {
    'id': 2927507,
    'nome': 'Santa Bárbara'
  },
  {
    'id': 2927606,
    'nome': 'Santa Brígida'
  },
  {
    'id': 2927705,
    'nome': 'Santa Cruz Cabrália'
  },
  {
    'id': 2927804,
    'nome': 'Santa Cruz da Vitória'
  },
  {
    'id': 2927903,
    'nome': 'Santa Inês'
  },
  {
    'id': 2928000,
    'nome': 'Santaluz'
  },
  {
    'id': 2928059,
    'nome': 'Santa Luzia'
  },
  {
    'id': 2928109,
    'nome': 'Santa Maria da Vitória'
  },
  {
    'id': 2928208,
    'nome': 'Santana'
  },
  {
    'id': 2928307,
    'nome': 'Santanópolis'
  },
  {
    'id': 2928406,
    'nome': 'Santa Rita de Cássia'
  },
  {
    'id': 2928505,
    'nome': 'Santa Teresinha'
  },
  {
    'id': 2928604,
    'nome': 'Santo Amaro'
  },
  {
    'id': 2928703,
    'nome': 'Santo Antônio de Jesus'
  },
  {
    'id': 2928802,
    'nome': 'Santo Estêvão'
  },
  {
    'id': 2928901,
    'nome': 'São Desidério'
  },
  {
    'id': 2928950,
    'nome': 'São Domingos'
  },
  {
    'id': 2929008,
    'nome': 'São Félix'
  },
  {
    'id': 2929057,
    'nome': 'São Félix do Coribe'
  },
  {
    'id': 2929107,
    'nome': 'São Felipe'
  },
  {
    'id': 2929206,
    'nome': 'São Francisco do Conde'
  },
  {
    'id': 2929255,
    'nome': 'São Gabriel'
  },
  {
    'id': 2929305,
    'nome': 'São Gonçalo dos Campos'
  },
  {
    'id': 2929354,
    'nome': 'São José da Vitória'
  },
  {
    'id': 2929370,
    'nome': 'São José do Jacuípe'
  },
  {
    'id': 2929404,
    'nome': 'São Miguel das Matas'
  },
  {
    'id': 2929503,
    'nome': 'São Sebastião do Passé'
  },
  {
    'id': 2929602,
    'nome': 'Sapeaçu'
  },
  {
    'id': 2929701,
    'nome': 'Sátiro Dias'
  },
  {
    'id': 2929750,
    'nome': 'Saubara'
  },
  {
    'id': 2929800,
    'nome': 'Saúde'
  },
  {
    'id': 2929909,
    'nome': 'Seabra'
  },
  {
    'id': 2930006,
    'nome': 'Sebastião Laranjeiras'
  },
  {
    'id': 2930105,
    'nome': 'Senhor do Bonfim'
  },
  {
    'id': 2930154,
    'nome': 'Serra do Ramalho'
  },
  {
    'id': 2930204,
    'nome': 'Sento Sé'
  },
  {
    'id': 2930303,
    'nome': 'Serra Dourada'
  },
  {
    'id': 2930402,
    'nome': 'Serra Preta'
  },
  {
    'id': 2930501,
    'nome': 'Serrinha'
  },
  {
    'id': 2930600,
    'nome': 'Serrolândia'
  },
  {
    'id': 2930709,
    'nome': 'Simões Filho'
  },
  {
    'id': 2930758,
    'nome': 'Sítio do Mato'
  },
  {
    'id': 2930766,
    'nome': 'Sítio do Quinto'
  },
  {
    'id': 2930774,
    'nome': 'Sobradinho'
  },
  {
    'id': 2930808,
    'nome': 'Souto Soares'
  },
  {
    'id': 2930907,
    'nome': 'Tabocas do Brejo Velho'
  },
  {
    'id': 2931004,
    'nome': 'Tanhaçu'
  },
  {
    'id': 2931053,
    'nome': 'Tanque Novo'
  },
  {
    'id': 2931103,
    'nome': 'Tanquinho'
  },
  {
    'id': 2931202,
    'nome': 'Taperoá'
  },
  {
    'id': 2931301,
    'nome': 'Tapiramutá'
  },
  {
    'id': 2931350,
    'nome': 'Teixeira de Freitas'
  },
  {
    'id': 2931400,
    'nome': 'Teodoro Sampaio'
  },
  {
    'id': 2931509,
    'nome': 'Teofilândia'
  },
  {
    'id': 2931608,
    'nome': 'Teolândia'
  },
  {
    'id': 2931707,
    'nome': 'Terra Nova'
  },
  {
    'id': 2931806,
    'nome': 'Tremedal'
  },
  {
    'id': 2931905,
    'nome': 'Tucano'
  },
  {
    'id': 2932002,
    'nome': 'Uauá'
  },
  {
    'id': 2932101,
    'nome': 'Ubaíra'
  },
  {
    'id': 2932200,
    'nome': 'Ubaitaba'
  },
  {
    'id': 2932309,
    'nome': 'Ubatã'
  },
  {
    'id': 2932408,
    'nome': 'Uibaí'
  },
  {
    'id': 2932457,
    'nome': 'Umburanas'
  },
  {
    'id': 2932507,
    'nome': 'Una'
  },
  {
    'id': 2932606,
    'nome': 'Urandi'
  },
  {
    'id': 2932705,
    'nome': 'Uruçuca'
  },
  {
    'id': 2932804,
    'nome': 'Utinga'
  },
  {
    'id': 2932903,
    'nome': 'Valença'
  },
  {
    'id': 2933000,
    'nome': 'Valente'
  },
  {
    'id': 2933059,
    'nome': 'Várzea da Roça'
  },
  {
    'id': 2933109,
    'nome': 'Várzea do Poço'
  },
  {
    'id': 2933158,
    'nome': 'Várzea Nova'
  },
  {
    'id': 2933174,
    'nome': 'Varzedo'
  },
  {
    'id': 2933208,
    'nome': 'Vera Cruz'
  },
  {
    'id': 2933257,
    'nome': 'Vereda'
  },
  {
    'id': 2933307,
    'nome': 'Vitória da Conquista'
  },
  {
    'id': 2933406,
    'nome': 'Wagner'
  },
  {
    'id': 2933455,
    'nome': 'Wanderley'
  },
  {
    'id': 2933505,
    'nome': 'Wenceslau Guimarães'
  },
  {
    'id': 2933604,
    'nome': 'Xique-Xique'
  }
]

export default cidadesBahia



// WEBPACK FOOTER //
// ./src/vuex/cache/cidadesBahia.js